import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationService {

  constructor() {}

  private _notification$ = new BehaviorSubject<any>(null);
  notification$ = this._notification$.asObservable();

  setNotification(notification: any) {
    this._notification$.next(notification);
  }

  clear() {
    this._notification$.next(null);
  }

}
